// ETHRAEON DemoCard · Phase S
// Verbatim per the KAIROS surface system spec.

import type { ReactNode } from "react";

interface DemoCardProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  onClick?: () => void;
}

export function DemoCard({ icon, title, subtitle, onClick }: DemoCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-left border border-neutral-200 dark:border-neutral-800 rounded-xl p-6 bg-white/70 dark:bg-neutral-900/60 hover:bg-neutral-50 dark:hover:bg-neutral-900 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 dark:focus-visible:ring-neutral-500"
    >
      <div className="mb-4 text-neutral-700 dark:text-neutral-200">{icon}</div>
      <h3 className="text-lg font-medium text-neutral-900 dark:text-neutral-50">{title}</h3>
      <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-1">{subtitle}</p>
    </button>
  );
}
